import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import App from "./App";
import "./index.css";
import { AuthProvider } from "./lib/auth-provider";
import { captureRecoverableHydrationError, initSentry } from "./lib/sentry";
import AppErrorFallback from "./components/layout/AppErrorFallback";

const queryClient = new QueryClient();
const rootElement = document.getElementById("root");

initSentry();

if (!rootElement) {
	throw new Error("Root element #root was not found");
}

const app = (
	<React.StrictMode>
		<BrowserRouter>
			<QueryClientProvider client={queryClient}>
				<AuthProvider>
					<Sentry.ErrorBoundary
						fallback={({ resetError }) => <AppErrorFallback onRetry={resetError} />}
						showDialog={false}
					>
						<App />
					</Sentry.ErrorBoundary>
				</AuthProvider>
			</QueryClientProvider>
		</BrowserRouter>
	</React.StrictMode>
);

if (rootElement.hasChildNodes()) {
	ReactDOM.hydrateRoot(rootElement, app, {
		onRecoverableError: (error, errorInfo) => {
			captureRecoverableHydrationError(error, errorInfo);
		},
	});
} else {
	ReactDOM.createRoot(rootElement).render(app);
}
